import styles from "./SearchInput.module.scss";

type Props = {
  className: string;
};

export const SearchInput = ({ className = "" }: Props) => {
  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    const target = e.target as typeof e.target & {
      term: { value: string };
    };
    const value = target.term.value.toUpperCase();
    window.location.href = `/search/search_results/${value}?sp=${value}`;
  };
  return (
    <form
      className={`${className} ${styles.searchInputWrapper} h-full flex items-center relative overflow-hidden`}
      onSubmit={handleSubmit}
    >
      <label htmlFor="search">
        <i className="material-icons" aria-hidden="true" data-icon="search"></i>
      </label>
      <input
        placeholder="Search Registrations"
        required
        data-position="bottom"
        data-delay="50"
        data-tooltip="TIP: Try Searching for Names, Jobs, Hobbies, Initials, etc."
        name="term"
        data-tooltip-id="75f1b7cf-efa6-9936-2878-55d81b434100"
        type="search"
        id="search"
        className="h-full"
      />
      <button
        type="submit"
        className={`flex items-center content-center border-none h-full absolute right-0  ${styles.searchButton}`}
      >
        <i
          className="material-icons"
          aria-hidden="true"
          data-icon="play_circle_outline"
        ></i>
      </button>
    </form>
  );
};
